export function init_modal() {

    const MODAL_TRIGGERS = document.querySelectorAll('.popup-trigger')
    const MODAL_CLOSE_TRIGGER = document.querySelector('.popup-modal__close')
    const BODY_OVERLAY = document.querySelector('.body-overlay')
    const BODY = document.querySelector('.has-subnav')
    const POPUP_MODAL = document.querySelector('.popup-modal')

    MODAL_TRIGGERS.forEach(trigger => {
        trigger.addEventListener('click', () => {

            POPUP_MODAL.classList.add('is--visible')
            BODY_OVERLAY.classList.add('is-blacked-out')
            BODY.classList.add('no-scroll')

            MODAL_CLOSE_TRIGGER.addEventListener('click', () => {
                POPUP_MODAL.classList.remove('is--visible')
                BODY_OVERLAY.classList.remove('is-blacked-out')
                BODY.classList.remove('no-scroll')
            })
        })
    })

}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/modal.js